<template>
	<div class="history-box" :class="{collapsed: closed}">
		<ul>
			<li>
				<div class="history-row-name first-in-the-history-box">
					File Name
				</div>
				<div class="history-row-value" style="padding-top: 2rem;">
					{{ scanDetails.fileName }}
				</div>
			</li>
			<li>
				<div class="history-row-name">
					Size
				</div>
				<div class="history-row-value">
					{{ (parseFloat(scanDetails.fileSize)/1048576).toFixed(3) }} MB
				</div>
			</li>
			<li v-if="scanDetails.upload_time">
				<div class="history-row-name">
					Upload Date
				</div>
				<div class="history-row-value">
					{{ scanDetails.upload_time }}	
				</div>
			</li>
			<li v-for="(value, name) in scanDetails.hash" :key="name">
				<div class="history-row-name history-hash"> {{ name }} </div>
				<div class="history-row-value"> {{ value }} </div>
			</li>
			<li v-for="(virus, avName, index) in scanDetails.avResponse" :key="avName">
				<div 
					class="history-row-name history-av" 
					:class="{ 'last-in-the-history-box' : index + 1 === Object.keys(scanDetails.avResponse).length}"
					>
					{{avName}}
				</div>
				<div v-if="virus === ''"  class="history-row-value">
					Virus Not Found
				</div>
				<div v-else class="history-row-value">
					{{ virus }}
				</div>
			</li>
      <i @click.prevent="toggler" class="history-icon">toggle</i>
		</ul>
	</div>
</template>

<script>
export default {    
    name: 'ScanDetails',
    props: [
        'scanDetails',
        'isClosed'
    ],
    data() {
      return {
        closed: this.isClosed
      }
    },
    methods: {
      toggler(){
        this.closed = !this.closed
      }
    }
}
</script>